import React from 'react';
import PhoneInput from 'material-ui-phone-number';
import {ValidatorComponent} from 'react-material-ui-form-validator';
import {Box, withStyles} from '@material-ui/core';
import {styles} from './styles';

/**
 * class to render phone input validator
 * @returns {JSX.Element}
 */
class PhoneInputValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      value,
      errorMessages,
      validators,
      validatorListener,
      ...rest
    } = this.props;

    return (
      <Box>
        <PhoneInput value={value} {...rest} />
        {this.errorText()}
      </Box>
    );
  }

  errorText() {
    const {isValid} = this.state;
    const {classes} = this.props;

    if (isValid) {
      return null;
    }

    return <Box className={classes.text}>{this.getErrorMessage()}</Box>;
  }
}

export default withStyles(styles)(PhoneInputValidator);
